import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico_Maximize",
  "use": "ico_Maximize-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ico_Maximize\">\n    <path data-name=\"Rectangle 2\" d=\"M7 7v10h10V7H7M6 6h12v12H6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol